var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "flex flex-col accordion-item",
      staticStyle: { overflow: "hidden" },
    },
    [
      _c("scheduler-item-row", {
        attrs: {
          leftMargin: _vm.getLeftForTimeLineMargin,
          backGroundColor: "",
          weekDates: _vm.weekDates,
          quarterMonths: _vm.quarterMonths,
          weeks: _vm.weeks,
          isDays: _vm.isDays,
          isMonths: _vm.isMonths,
          isWeeks: _vm.isWeeks,
          columnSpan: _vm.columnSpan,
        },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("employee-item", {
                  attrs: {
                    isManager: true,
                    projects: _vm.manager.projects,
                    contractors: _vm.manager.contractors,
                    projectsInprogress: _vm.projectsInprogress,
                    projectsCompleted: _vm.completedProjects,
                    isOpened: _vm.isOpened,
                    item: _vm.manager,
                    isInner: false,
                    color: _vm.color,
                    filterBy: "maganer",
                  },
                  on: { toggleCollapse: _vm.toggleCollapse },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "progress",
            fn: function () {
              return [
                _c(
                  "circle-progress-item",
                  {
                    attrs: {
                      hasData: true,
                      item: _vm.manager,
                      completed: _vm.completedProjects,
                      color: _vm.color,
                      total: _vm.manager.projects.length,
                    },
                  },
                  [
                    _c("span", { staticClass: "inner-text" }, [
                      _vm._v(
                        _vm._s(_vm.completedProjects) +
                          "/" +
                          _vm._s(_vm.manager.projects.length)
                      ),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "progressBar",
            fn: function () {
              return [
                _c("progress-item", {
                  attrs: {
                    item: _vm.manager,
                    color: _vm.color,
                    progress: _vm.getManagerProgressWidth,
                    width: _vm.managerProgressWidth,
                    marginLeft: _vm.getLeftMargin,
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.isOpened
        ? [
            _vm._l(_vm.manager.projects, function (project) {
              return [
                _vm.manager.projects.length > 0
                  ? _c("scheduler-item-row", {
                      staticClass: "text-base font-semibold",
                      attrs: {
                        leftMargin: _vm.getLeftForTimeLineMargin,
                        backGroundColor: "rgba(2, 163, 218, 0.1)",
                        weekDates: _vm.weekDates,
                        quarterMonths: _vm.quarterMonths,
                        weeks: _vm.weeks,
                        isDays: _vm.isDays,
                        isMonths: _vm.isMonths,
                        isWeeks: _vm.isWeeks,
                        columnSpan: _vm.columnSpan,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "left",
                            fn: function () {
                              return [
                                _c("project-item", {
                                  attrs: {
                                    isOpened: _vm.isOpened,
                                    item: project.project,
                                    isInner: true,
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "progress",
                            fn: function () {
                              return [
                                _c(
                                  "circle-progress-item",
                                  {
                                    attrs: {
                                      hasData: true,
                                      item: project.project,
                                      color: _vm.color,
                                      completed:
                                        _vm.getCompletedProjectActivitiesActivities(
                                          project.project
                                        ),
                                      total:
                                        project?.project?.project_activities
                                          .length,
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "inner-text" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getCompletedProjectActivitiesActivities(
                                            project.project
                                          )
                                        ) +
                                          "/" +
                                          _vm._s(
                                            project?.project?.project_activities
                                              .length
                                          )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "progressBar",
                            fn: function () {
                              return [
                                _c("progress-item", {
                                  attrs: {
                                    item: project.project,
                                    color: _vm.color,
                                    type: "project",
                                    currentUser: _vm.currentUser,
                                    companyId: _vm.companyId,
                                    progress: _vm.getProjectProgressWidth(
                                      project.project
                                    ),
                                    width: _vm.getProjectProgressItemWidth(
                                      project.project
                                    ),
                                    marginLeft: _vm.getProjectLeftMargin(
                                      project.project
                                    ),
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e(),
                _vm._l(
                  project.project.project_activities,
                  function (activity, index) {
                    return project.project.project_activities.length > 0
                      ? _c("scheduler-item-row", {
                          key: activity.id,
                          staticClass: "text-base",
                          attrs: {
                            leftMargin: _vm.getLeftForTimeLineMargin,
                            backGroundColor: "#F2F2F2",
                            weekDates: _vm.weekDates,
                            quarterMonths: _vm.quarterMonths,
                            weeks: _vm.weeks,
                            isDays: _vm.isDays,
                            isMonths: _vm.isMonths,
                            isWeeks: _vm.isWeeks,
                            columnSpan: _vm.columnSpan,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "left",
                                fn: function () {
                                  return [
                                    _c("activity-item", {
                                      attrs: {
                                        item: activity,
                                        index: index,
                                        currentUser: _vm.currentUser,
                                        companyId: _vm.companyId,
                                        project: project,
                                        color: _vm.color,
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "progress",
                                fn: function () {
                                  return [
                                    _c(
                                      "circle-progress-item",
                                      {
                                        attrs: {
                                          hasData: true,
                                          item: activity,
                                          color: _vm.color,
                                          completed:
                                            _vm.getActivityCompletedSteps(
                                              activity
                                            ),
                                          total: 10,
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "inner-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getActivityPercentageComplete(
                                                  activity
                                                )
                                              ) + "%"
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "progressBar",
                                fn: function () {
                                  return [
                                    _c("progress-item", {
                                      attrs: {
                                        item: activity,
                                        color: _vm.color,
                                        type: "activity",
                                        project: project.project,
                                        progress:
                                          _vm.getActivityProgressWidth(
                                            activity
                                          ),
                                        width:
                                          _vm.getActivityProgressitemWith(
                                            activity
                                          ),
                                        marginLeft:
                                          _vm.getActivityLeftMargin(activity),
                                        currentUser: _vm.currentUser,
                                        companyId: _vm.companyId,
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e()
                  }
                ),
                _c("scheduler-item-row", {
                  attrs: {
                    leftMargin: _vm.getLeftForTimeLineMargin,
                    backGroundColor: "#F2F2F2",
                    weekDates: _vm.weekDates,
                    quarterMonths: _vm.quarterMonths,
                    weeks: _vm.weeks,
                    isDays: _vm.isDays,
                    isMonths: _vm.isMonths,
                    isWeeks: _vm.isWeeks,
                    columnSpan: _vm.columnSpan,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function () {
                          return [
                            _c("add-activity-item", {
                              attrs: {
                                type: "activity",
                                currentUser: _vm.currentUser,
                                companyId: _vm.companyId,
                                project: project.project,
                                message: "Add Task",
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "progress",
                        fn: function () {
                          return [
                            _c("circle-progress-item", {
                              attrs: { hasData: false },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ]
            }),
            _vm.manager.projects.length <= 0
              ? _c("scheduler-item-row", {
                  attrs: {
                    leftMargin: _vm.getLeftForTimeLineMargin,
                    backGroundColor: "#F2F2F2",
                    weekDates: _vm.weekDates,
                    quarterMonths: _vm.quarterMonths,
                    weeks: _vm.weeks,
                    isDays: _vm.isDays,
                    isMonths: _vm.isMonths,
                    isWeeks: _vm.isWeeks,
                    columnSpan: _vm.columnSpan,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function () {
                          return [
                            _c("add-activity-item", {
                              attrs: {
                                type: "project",
                                message: "Add Project",
                                currentUser: _vm.currentUser,
                                companyId: _vm.companyId,
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "progress",
                        fn: function () {
                          return [
                            _c("circle-progress-item", {
                              attrs: { hasData: false },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    4108072319
                  ),
                })
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }